export default __webpack_public_path__ + "static/media/cert-E-commerce-hkgcsmeaa.989dfc3a.jpg";